export default "__VITE_ASSET__BsmMek3J__"